import localforage from "localforage";

export class ImageCacheManager {
  constructor(storeName = "productDetailsImages") {
    this.cache = localforage.createInstance({
      name: "unleash",
      storeName,
      version: 1.0,
      driver: [localforage.INDEXEDDB],
    });
  }

  static extractExpirationFromUrl(url) {
    const match = url.match(/Expires=(\d+)/);
    return match ? parseInt(match[1], 10) : null;
  }

  async getCachedImageVariationById(productId) {
    if (!productId) return null;

    const cached = await this.cache.getItem(productId);

    if (!cached) {
      return null;
    }
  
    const now = Math.floor(Date.now() / 1000);
    if (cached.expiresAt && now < cached.expiresAt) {
      return cached.url;
    }

    await this.cache.removeItem(productId);
  
    return null;
  }

  async setCachedImageVariationById(productId, url) {
    const expiresAt = ImageCacheManager.extractExpirationFromUrl(url);

    if (!expiresAt) {
      return;
    }
  
    const data = {
      url,
      expiresAt,
    };
  
    await this.cache.setItem(productId, data);
  }

  async getCachedImages(id) {
    if (!id) return null;

    try {
      const cached = await this.cache.getItem(id);
      if (!cached) return null;

      const now = Math.floor(Date.now() / 1000);
      if (cached.expiresAt && now < cached.expiresAt) {
        return cached.urls;
      }

      console.log(`Cache expired for ID: ${id}`);
      await this.cache.removeItem(id);
      return null;
    } catch (error) {
      return null;
    }
  }

  async setCachedImages(id, urls = []) {
    if (!id || !Array.isArray(urls) || urls.length === 0) return;

    const firstValidUrl = urls.find(
      (url) => typeof url === "string" || typeof url?.url === "string"
    );

    const rawUrl =
      typeof firstValidUrl === "string" ? firstValidUrl : firstValidUrl?.url;
    const expiresAt = ImageCacheManager.extractExpirationFromUrl(rawUrl);

    if (!expiresAt) {
      return;
    }

    const data = { urls, expiresAt };

    await this.cache.setItem(id, data);
    console.log(
      `Image URLs cached for ID: ${id} until ${new Date(
        expiresAt * 1000
      ).toLocaleString()}`
    );
  }

  async clearCacheById(id) {
    try {
      await this.cache.removeItem(id);
    } catch (error) {
      console.error(`Failed to remove cache for ID: ${id}`, error);
    }
  }

  async clearAll() {
    try {
      await this.cache.clear();
    } catch (error) {
      console.error("Failed to clear all image cache", error);
    }
  }
}
